var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2469 12.4632L10.906 9.15101C8.39863 6.30822 4.46095 9.85719 7.56515 12.9363C10.2379 15.5874 12.8151 18.1429 13.7696 19.0892C16.7489 22.0429 22.2394 17.1896 19.0196 13.4112C16.3469 10.7615 10.2697 4.73657 7.56515 2.05531C4.22412 -1.25427 -1.6239 3.93986 2.31514 7.73328C3.07881 8.48777 3.90609 9.30728 4.22427 9.62272",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.73a56a84.svg";
export { ForwardRef as ReactComponent };